document.addEventListener("DOMContentLoaded", function () {
  const iconGroups = [
    {
      texts: ["LED Bloklys", "Se alle LED Bloklys", "Alle anzeigen LED Blockkerzen", "LED-Blockkerzen", "LED -Blocklichter", "Geleid Stompkaarsen", "LED Blockkerzen", "LED Pillar candle", "DIRIGÉ Bougie pilier" ,"GUIDATO Candela a pilastro" , "CONDUJO Vela pilar" ,"LED Pylväskynttilä","LIDERADO Vela pilar" ,"LED Bougie pilier","LED Stompkaarsen","LED Blockljus",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Bloklys_c7a9343c-0b39-4766-984e-08405dd0aeb7.png?v=1741682664"
    },
    {
      texts: ["LED Fyrfadslys", "LED-Teelichter", "Geleid Waxinelichtjes", "LED Tealight candle", "LED Teelichter", "DIRIGÉ Bougie chauffe-plat" ,"GUIDATO Candela tealight" , "CONDUJO Vela de té" ,"LED Tuikkukynttilä" ,"LIDERADO Vela de chá","LED Bougie chauffe-plat","LED Waxinelichtjes","LED Värmeljus"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Fyrfadslys_e222139b-522d-4da7-baf1-a5db39cdfe9e.png?v=1741682664"
    },
    {
      texts: ["LED Kertelys", "Geleid Glanzende Dinerkaars", "LED Shiny Dinner candle", "LED Kerzenlicht Mit Lack" ,"DIRIGÉ Bougie effilée" , "GUIDATO Candela affusolata" ,"CONDUJO Vela cónica delgada","LED Kapea kynttilä" ,"LIDERADO Vela afilada","LED Bougie effilée","LED Glanzende dinerkaars","LED Ljus Med Lack"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Kertelys_d9bdbb63-284d-4920-8ee7-073fff545e04.png?v=1741682664"
    },
    {
      texts: ["LED Kronelys", "LED-Stabkerzen", "Geleid Dinerkaars", "LED Dinner candle", "LED Stabkerzen" ,"DIRIGÉ Bougie chandelier" , "GUIDATO Candela da candelabro" ,"CONDUJO Vela para candelabro","LED Kruunukynttilä" ,"LIDERADO Vela fina","LED Bougie chandelier","LED Dinerkaars","LED Kronljus"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Kronelys_87fccf24-0a29-48aa-8cbb-370dd29bb4e2.png?v=1741682665"
    },
    {
      texts: ["LED Keglelys", "LED-Kegelkerzen", "Geleid Kegelkaarsen", "LED Cone candle", "LED Kegelkerze" ,"DIRIGÉ Bougie conique" , "GUIDATO Candela conica" ,"CONDUJO Vela cónica","LED Kartiokynttilä" ,"LIDERADO Vela cónica","LED Bougie conique","LED Kegelkaarsen","LED Kegelljus"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Keglelys_5446f403-0b3e-48bf-9b6f-3a47bcce0b73.png?v=1741682664"
    },
    {
      texts: ["LED Rillelys", "LED-Rillenkerzen", "Geleid Ribbelkaarsen", "LED Ribbed candle", "LED Rillenkerzen" ,"DIRIGÉ Bougie rainurée" , "GUIDATO Candela rigata" ,"CONDUJO Vela acanalada","LED uritettu kynttilä" ,"LIDERADO Vela canelada","LED Bougie rainurée","LED Ribbelkaarsen","LED Rilleljus"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Rillelys_71d90cc1-62b6-40ac-8226-4dbf96a34255.png?v=1741682665"
    },
    {
      texts: ["Unique Candles"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Solid_stripe_light.png?v=1741858265"
    },
    {
      texts: ["Deco Style"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Harlequin_faeb0206-90ef-4808-8261-c6eacf769fe6.png?v=1741683035"
    },
    {
      texts: ["Ikon Copenhagen"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Ikon_copenhagen.png?v=1754472474"
    },
    {
      texts: ["Fjernbetjeninger", "Télécommandes", "Afstandsbedieningen", "Fjärrkontroller", "Fernbedienungen", "Afstandsbediening", "Remote control", "Fernbedienung" ,"Télécommande" , "Telecomando" ,"Mando a distancia","Kaukosäädin" ,"Controle remoto","Fjärrkontroll","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Fjernbetjening.png?v=1741683244"
    },
    {
      texts: ["Batterier", "Piles", "Batterijen", "Batteries", "Batterien" ,"Batteurs" , "Batterie" ,"Baterías","Paristot" ,"Baterias","","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Batterier.png?v=1741683246"
    },
    {
      texts: ["Udendørs LED Bloklys", "En plein air LED Bougie pilier", "Buiten LED Stompkaarsen", "Utomhus LED Blockljus", "Draußen LED Blockkerzen", "Outdoor Blockkerzen", "Buitenshuis Stompkaarsen", "Outdoors Pillar candle", "Draußen Blockkerzen" ,"En plein air Bougie pilier" , "All'aperto Candela a pilastro" ,"Al aire libre Vela pilar","Ulkona Pylväskynttilä" ,"Ao ar livre Vela pilar","LED outdoor blockkerzen","Utomhus Blockljus",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Udendors_LED_Bloklys_178fcc29-6942-4091-a867-af88e8680a2e.png?v=1741682664"
    },
    {
      texts: ["LED Flydelys", "LED Bougie flottante", "LED Drijfkaarsen", "LED Schwimmende Lichter", "LED Flytande ljus", "Floating Light", "Vluchtlicht", "Floating candle", "Fluglicht" ,"Bougie flottante" , "Candela galleggiante" ,"Vela flotante","Kelluva kynttilä" ,"Vela flutuante","Drijfkaarsen","Flygljus",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Flydelys_86e30cb9-2710-4592-ba4a-dedb76540158.png?v=1741684737"
    },
    {
      texts: ["LED Lyskæde", "LED Guirlande de lumières", "LED Lichtsnoer", "LED Sträng av ljus", "LED Lichterkette", "LED -lichte ketens", "LED light chains", "LED -Lichtketten" ,"Chaînes lumineuses LED" , "Catene di luce a LED" ,"Cadenas de luz LED","LED -valoketjut" ,"Correntes leves LED","LED Lichtketten","LED Light chains","LED Chaînes légères", "LED Lichte ketens", "LED Ljuskedjor","LED Kevyet ketjut"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/LED_Lyskaeder.png?v=1742223492"
    },
    {
      texts: ["LED Lanterner", "LED-Laternen", "Led lantaarns", "Led lanterns", "Led Laternen" ,"Lanternes conduites" , "Lanterne guidate" ,"Linternas LED","LED Lanterns" ,"Lanternas LED","LED Laternen","LED Lanternes","LED Lantaarns", "LED Lyktor", "LED Lyhty"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/LED_Lanterner.png?v=1742225190"
    },
    {
      texts: ["LED Gravlys", "LED burial light", "LED Grablicht" ,"Lumière en sépulture LED" , "Luce di sepoltura a LED" ,"Luz de entierro LED","LED -hautausvalo" ,"Luz de enterro LED","","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/LED_Gravlys_00e86e78-44aa-4751-914a-1036db08e976.png?v=1741682664"
    },
    {
      texts: ["Bakker", "Dienbladen", "Trays", "Tabletts" ,"Plateaux" , "Vassoi" ,"Bandejas","Tarjottimet" ,"Tabuleiros","Brickor","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Bakker_2b28c4e2-d1e4-4146-b687-7c37b667e01b.png?v=1741682673"
    },
    {
      texts: ["Vaser", "Vazen", "Vases", "Vasen" ,"Vasi" , "Jarrones" ,"Maljakko","Vasos" ,"","","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Vaser_d5d163e9-d401-472c-a127-e102f718a988.png?v=1741682672"
    },
    {
      texts: ["Kunstige blomster", "Kunstbloemen", "Artificial flowers", "Künstliche Blumen" ,"Fleurs artificielles" , "Fiori artificiali" ,"Flores artificiales","Keinotekoiset kukat" ,"Flores artificiais","Konstgjorda blommor","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Kunstige_blomster_ec77ed75-e512-49bf-a959-fa53aa8665f0.png?v=1741682672"
    },
    {
      texts: ["Lysestager", "Kerzenhalter", "Kandelaars", "Candlesticks", "Chandelles" ,"Candelabri" , "Cellestas" ,"Kynttilänjalat","Ljusstakar" ,"","","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lysestager_6d16ebe2-0a1e-422e-af87-ed8d3cc32f97.png?v=1741682673"
    },
    {
      texts: ["Lanterner", "Lantaarns", "Lanterns", "Laternen" ,"Lanternes" , "Lanterne" ,"Linternas","Lyhty" ,"Lanternas","Lyktor","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lanterner_8c27cf0a-066d-4fee-930f-59d46971ebc7.png?v=1741682673"
    },
    {
      texts: ["Jul", "Kerstmis", "Christmas", "Weihnachten" ,"Noël" , "Natale" ,"Navidad","joulu" ,"Natal","","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Jul_ed722bf5-9e1c-41d0-b817-dc64580fe083.png?v=1741682665"
    },
    {
      texts: ["Påske", "Pasen", "påsk", "Easter", "Ostern" ,"Pâques" , "Pasqua" ,"Pascua de Resurrección","pääsiäinen" ,"Páscoa","Påsk","",""],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Paske_e705cbc8-9620-4b16-8e0f-b9d98d2ca2ce.png?v=1741682665"
    },
    {
      texts: ["Bordeaux"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Bordeaux_e9af4bfe-7052-4bf6-b62e-9e6223255b06.png?v=1754578641"
    },
    {
      texts: ["Bourgogne","Burgunderrot","Borgogna"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Bourgogne_c46abaa1-ad13-4dc5-9ce5-7f4f859b908c.png?v=1754578642"
    },
    {
      texts: ["Cream","Creme","Kräm","Crème","Crema"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Cream_9dc96a02-6e5a-42c7-8cfc-033aa64f2807.png?v=1754578641"
    },
    {
      texts: ["Grå","Grau","Grijs","Gris","Grigio"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Gra.png?v=1754578641"
    },
    {
      texts: ["Hvid","Weiß","Vit","Wit","Blanc","Bianco"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Hvid_8c9eec8b-9550-4f72-a978-4710dedea53a.png?v=1754578641"
    },
    {
      texts: ["Isblå","Eisblau","Ijsblauw","Bleu glace","Blu ghiaccio"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Isbla.png?v=1754578641"
    },
    {
      texts: ["Jade Grøn", "Jade grøn","Jadegrün","Jadegrön","Jadegroen","Vert jade","Verde giada"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Jade_Gron_31a0c56d-84b8-4e53-8377-47b6542ef764.png?v=1754578641"
    },
    {
      texts: ["Karamel", "Karamell","Caramel","Caramello"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Karamel.png?v=1754578641"
    },
    {
      texts: ["Karry","Curry"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Karry.png?v=1754578641"
    },
    {
      texts: ["Kongeblå","Königsblau","Kungsblå","Koningsblauw","Bleu roi","Blu reale"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Kongebla.png?v=1754578641"
    },
    {
      texts: ["Lavendel","Lavande","Lavanda"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lavendel.png?v=1754578641"
    },
    {
      texts: ["Lysegul","Hellgelb","Ljusgul","Lichtgeel","Jaune clair","Giallo chiaro"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lysegul.png?v=1754578641"
    },
    {
      texts: ["Lyserød","Hellrosa","Ljusrosa","Lichtroze","Rose clair","Rosa chiaro"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lyserod.png?v=1754578642"
    },
    {
      texts: ["Lyslilla","Helllila","Ljuslila","Lichtpaars","Violet clair","Viola chiaro"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lyslilla.png?v=1754578641"
    },
    {
      texts: ["Magenta"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Magenta_c1e6674b-f528-44f7-9774-2ccab1d5c72f.png?v=1754578642"
    },
    {
      texts: ["Mint","Minze","Munt","Menthe","Menta"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Mint_5f25b080-19d7-4b2c-ad92-aa5a8dc059f0.png?v=1754578641"
    },
    {
      texts: ["Mokka","Mocca","Moka","Mocha"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Mokka_ad12f56e-9bca-4411-b576-eb1481d627a0.png?v=1754578641"
    },
    {
      texts: ["Mørkegrøn","Dunkelgrün","Mörkgrön","Donkergroen","Vert foncé","Verde scuro"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Morkegron.png?v=1754578641"
    },
    {
      texts: ["Mørkelilla","Dunkellila","Mörklila","Donkerpaars","Violet foncé","Viola scuro"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Morkelilla.png?v=1754578641"
    },
    {
      texts: ["Olivengrøn","Olivgrün","Olivgrön","Olijfgroen","Vert olive","Verde oliva"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Olivengron.png?v=1754578641"
    },
    {
      texts: ["Orange","Oranje","Arancione"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Orange_6c201042-884b-4dac-955e-e589d9df4e14.png?v=1754578641"
    },
    {
      texts: ["Petroleum","Petrol","Pétrole","Petrolio"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Petroleum_bd4ee9f7-1b33-47cf-b584-998bd0ce04de.png?v=1754578641"
    },
    {
      texts: ["Rose","Rosa","Roze","Rosso"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Rose_4ce2958b-3289-4867-825f-21957ebb415e.png?v=1754578641"
    },
    {
      texts: ["Rød","Rot","Röd","Rood","Rouge"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Rod.png?v=1754578641"
    },
    {
      texts: ["Salvie grøn","Salbeigrün","Salviagrön","Saliegroen","Vert sauge","Verde salvia"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Salvie_gron.png?v=1754578642"
    },
    {
      texts: ["Sand","Zand","Sable","Sabbia"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Sand_a934aeac-4a9f-472f-899d-18b17a97923b.png?v=1754578641"
    },
    {
      texts: ["Sort","Schwarz","Svart","Zwart","Noir","Nero"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Sort.png?v=1754578641"
    },
    {
      texts: ["Støvet blå","Verblasst Blau","Stövet blå","Vergrijsd blauw","Bleu poussiéreux","Blu polveroso"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Stovet_bla.png?v=1754578641"
    },
    {
      texts: ["Støvet grøn","Verblasst Grün","Stövet grön","Vergrijsd groen","Vert poussiéreux","Verde polveroso"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Stovet_gron.png?v=1754578641"
    },
    {
      texts: ["Støvet rød"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Stovet_rod.png?v=1754578641"
    },
    {
      texts: ["Violet","Violett","Viola"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Violet_72c2728e-8469-4a1f-ac75-8ac26214ba9b.png?v=1754578641"
    },
    {
      texts: ["Blåbær blå","Stone Blue"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Blabaer_bla.png?v=1754578642"
    },
    {
      texts: ["Sølv","Space Grey"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Solv.png?v=1754578641"
    },
    {
      texts: ["Lysegrå","Light Grey"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Lysegra.png?v=1754578641"
    },
    {
      texts: ["Kobber","Bronze"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Kobber.png?v=1754578641"
    },
    {
      texts: ["Messing","Brass Gold"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Messing.png?v=1754578641"
    },
    {
      texts: ["Beige"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Beige.png?v=1754578641"
    },
    {
      texts: ["Vinter", "Winter", "Hiver"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Vinter.png?v=1768481924"
    },
    {
      texts: ["Sommer", "Sommar", "Zomer", "Été"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Sommer.png?v=1768481927"
    },
    {
      texts: ["Efterår", "Herbst", "Höst", "Herfst", "Automne"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Efterar.png?v=1768481930"
    },
    {
      texts: ["Forår", "Frühling", "Fjädra", "Lente", "Printemps"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Forar.png?v=1768481933"
    },
    {
      texts: ["Unique LED Bloklys"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Rustic.png?v=1741858264"
    },
    {
      texts: ["Unique LED Rillelys"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Solid_stripe_light.png?v=1741858265"
    },
    {
      texts: ["Unique Fjernbetjening"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Unique_remote.png?v=1741858268"
    },
    {
      texts: ["Harlequin"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Harlequin_faeb0206-90ef-4808-8261-c6eacf769fe6.png?v=1741683035"
    },
    {
      texts: ["Solid Stripe"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Shape_dcc3fda3-a877-462e-8881-3ac8496b210f.png?v=1741683039"
    },
    {
      texts: ["Square"],
      url: "https://cdn.shopify.com/s/files/1/0612/2599/2348/files/Square_42634bca-19af-4ce9-8491-587898888401.png?v=1741683037"
    },
  ];

  const iconMap = {};
  iconGroups.forEach(group => {
    group.texts.forEach(text => {
      iconMap[text] = group.url;
    });
  });

  function addIcons(links) {
    links.forEach(link => {
      const navText = link.textContent.trim();
      const iconUrl = iconMap[navText];

      if (iconUrl) {
        const img = document.createElement("img");
        img.classList.add("menuIconDavi");
        img.src = iconUrl;
        link.insertBefore(img, link.firstChild);
      }
    });
  }

  const mobileMenuLinks = document.querySelectorAll('#m-menu-drawer .m-menu-mobile__link');

  addIcons(mobileMenuLinks);
});

